import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c715872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 container" }
const _hoisted_2 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("車台番号：")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}, " YES ", -1 /* HOISTED */))
const _hoisted_11 = {
  class: "modal fade",
  id: "inputErrorModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "正しい値を入力してください")
], -1 /* HOISTED */))
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"completeModal\" tabindex=\"-1\" aria-hidden=\"true\" data-v-3c715872><div class=\"modal-dialog modal-dialog-centered\" data-v-3c715872><div class=\"modal-content\" data-v-3c715872><div class=\"modal-header\" data-v-3c715872><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-3c715872></button></div><div class=\"modal-body\" data-v-3c715872><p data-v-3c715872>送信完了しました</p></div><div class=\"modal-footer\" data-v-3c715872><button type=\"button\" class=\"btn btn-primary\" data-bs-dismiss=\"modal\" data-v-3c715872> YES </button></div></div></div></div>", 1)
const _hoisted_18 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_19 = {
  key: 1,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, "車台番号を送信してください")
], -1 /* HOISTED */))
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "車台番号送信", -1 /* HOISTED */))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "rounded-3 mt-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "シリアル番号", -1 /* HOISTED */))
const _hoisted_26 = {
  id: "serialNo",
  class: "col-auto d-flex justify-content-center"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "車台番号", -1 /* HOISTED */))
const _hoisted_28 = { class: "col-auto d-flex justify-content-center" }
const _hoisted_29 = {
  key: 0,
  class: "col-auto col-form-label text-danger"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "シリアル番号、車台番号登録", -1 /* HOISTED */))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "d-flex justify-content-end" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "戻る", -1 /* HOISTED */))
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createCommentVNode(" モーダル "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, [
              _hoisted_7,
              _hoisted_8,
              _createTextVNode(_toDisplayString($setup.vinNo), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.inputFix()))
            }, " NO "),
            _hoisted_10
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.inputFix()))
            }, " YES ")
          ])
        ])
      ])
    ]),
    _hoisted_17,
    ($setup.ocrError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, " もう一度画像送信してください "))
      : _createCommentVNode("v-if", true),
    ($setup.postTieDataValidationError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 登録に失敗しました。 "))
      : _createCommentVNode("v-if", true),
    _hoisted_20,
    _createElementVNode("img", {
      class: "image-area mb-1 mt-1",
      src: $setup.url
    }, null, 8 /* PROPS */, _hoisted_21),
    _createElementVNode("form", null, [
      _createElementVNode("input", {
        type: "file",
        onChange: $setup.selectedFile
      }, null, 32 /* HYDRATE_EVENTS */),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary mt-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.submitPicture()))
      }, _hoisted_23)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, _toDisplayString($setup.serialNo), 1 /* TEXT */),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("input", {
          id: "vinNo",
          type: "text",
          class: "form-control w-75 text-center",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.vinNo) = $event)),
          onInput: $setup.validateVinNo,
          maxlength: "12"
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [
            _vModelText,
            $setup.vinNo,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", null, [
        ($setup.failureText)
          ? (_openBlock(), _createElementBlock("label", _hoisted_29, "※車台番号を正しく入力してください"))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary mt-2",
      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.submitTieData()))
    }, _hoisted_31),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary mt-2",
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.returnInitialPage()))
      }, _hoisted_34)
    ])
  ]))
}